class @App.Components.TempUserTimer
  constructor: ->
    @timeoutWarning = 480000 # Display warning in 8 mins.
    @timeoutNow = 120000 # Warning has been shown, give user 2 mins to interact
    @logoutUrl = '/timeout' # URL to logout page.

    setTimeout periodicalQuery, 30000

    ## Button click handlers ##
    # timeout and redirect on close page
    $(document).on 'click', '.js-temp-user-logout', =>
      @timeout()

    # click continue, or in lesson panel
    $(document).on 'click', '.js-temp-user-continue,
                             .lessonsShowView .panels', =>
      @reset()

    # end session on click "next section"
    $(document).on 'click', '.nextS a', =>
      console.log 'ending session'
      @endSession()

    # add duration of video remaining to timer if playing started
    $(document).on 'VideoPlayer::started', (e, target) =>
      currentTime = target.getCurrentTime()
      videoDuration = target.getDuration()
      if videoDuration
        @reset(@timeoutWarning + ((videoDuration - currentTime) * 1000))

    # reset timer to default if video paused
    $(document).on 'VideoPlayer::paused', (e, target) =>
      @reset()

  # Logout the user
  timeout: ->
    console.log 'timeout'
    window.location = @logoutUrl

  endSession: ->
    console.log 'end session'
    $.ajax
      type: 'get'
      dataType: 'script'
      url: @logoutUrl

  # Show idle timeout warning dialog.
  warning: ->
    console.log 'warning'
    clearTimeout @warningTimer
    @timeoutTimer =
      setTimeout (=>
        @timeout()
      ), @timeoutNow
    BetterModals.showModal $('#modalLogoutWarning')
    # Initiate a realtime countdown within the modal
    countdownTimer (@timeoutNow / 1000), $('#countdown-timer')

  # Start warning timer.
  start: (duration) ->
    console.log 'start'

    @warningTimer =
      setTimeout (=>
        @warning()
      ), (duration || @timeoutWarning)

  # Reset timers.
  reset: (duration) ->
    console.log 'reset'
    clearTimeout @warningTimer
    clearTimeout @timeoutTimer
    @start(duration)
    BetterModals.closeModal $('#modalLogoutWarning')

  # A countdown timer that we can use for display in the warning modal
  countdownTimer = (duration, display) ->
    timer = duration
    minutes = undefined
    seconds = undefined
    setInterval (->
      minutes = parseInt(timer / 60, 10)
      seconds = parseInt(timer % 60, 10)
      minutes = if minutes < 10 then '0' + minutes else minutes
      seconds = if seconds < 10 then '0' + seconds else seconds
      display.text minutes + ':' + seconds
      if --timer < 0
        timer = duration
      return
    ), 1000
    return

  # We use a server heartbeat so that closed browsers might also terminate
  # the session.
  periodicalQuery = ->
    $.ajax
      url: '/active'
      success: (data) ->
        if data.live == false
          # Session ended by server
          @endSession()
        return
    setTimeout periodicalQuery, 30000
    return
